(() => {
  const preserved = 'summary,.native-pagination,.pagination,[data-product-zoom],[data-gallery-prev],[data-gallery-next],[data-aplus-prev],[data-aplus-next],[data-hero-prev],[data-hero-next],.hero-carousel-control,[data-product-reviews],.reputon-widget,.shopify-payment-button,shopify-accelerated-checkout,video,audio';
  const pending = new Set();
  let frame = 0;
  let observer;
  const cleanControl = control => {
    if (control.closest(preserved)) return;
    if (control.tagName === 'BUTTON' && /^[\s↗↓]*$/u.test(control.textContent)) return;
    control.querySelectorAll('.teching-decorative-arrow').forEach(element => {
      if (!/^[\s↗↓]+$/u.test(element.textContent)) element.classList.remove('teching-decorative-arrow');
    });
    const walker = document.createTreeWalker(control, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      const parent = node.parentElement;
      if (!parent || parent.closest('svg,script,style,template') || parent.closest(preserved)) continue;
      const value = node.nodeValue;
      if (!/[↗↓]/u.test(value)) continue;
      if (parent !== control && parent.matches('span,b,i') && parent.childElementCount === 0 && /^[\s↗↓]+$/u.test(value)) {
        parent.classList.add('teching-decorative-arrow');
        continue;
      }
      const cleaned = value.replace(/\s*[↗↓]\s*$/u, '');
      if (cleaned !== value) {
        node.nodeValue = cleaned;
      }
    }
  };
  const scan = root => {
    if (!root.isConnected) return;
    if (root.matches?.('a[href],button')) cleanControl(root);
    root.querySelectorAll?.('a[href],button').forEach(cleanControl);
  };
  const flush = () => {
    frame = 0;
    observer.disconnect();
    pending.forEach(scan);
    pending.clear();
    observer.observe(document.body, {childList:true,subtree:true,characterData:true});
  };
  const schedule = root => {
    const element = root.nodeType === Node.ELEMENT_NODE ? root : root.parentElement;
    if (!element || element.closest(preserved)) return;
    pending.add(element.closest('a[href],button') || element);
    if (!frame) frame = requestAnimationFrame(flush);
  };
  const sync = () => {
    observer.disconnect();
    if (frame) cancelAnimationFrame(frame);
    frame = 0;
    pending.clear();
    scan(document.body);
    observer.observe(document.body, {childList:true,subtree:true,characterData:true});
  };
  observer = new MutationObserver(records => records.forEach(record => {
    if (record.type === 'characterData') schedule(record.target);
    else {
      const control = record.target.closest?.('a[href],button');
      if (control) schedule(control);
      record.addedNodes.forEach(schedule);
    }
  }));
  document.addEventListener('shopify:section:load', event => schedule(event.target));
  sync();
})();
